var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoiShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "170px",
    height: "170px",
    viewBox: "0 0 170 170",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.64739045%",
    y1: "50%",
    x2: "100%",
    y2: "44.9945881%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8B00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F06400",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 16,
    fill: "url(#linearGradient-1)",
    cx: 77,
    cy: 77,
    r: 77
  }), /*#__PURE__*/React.createElement("g", {
    id: "build_black_24dp",
    transform: "translate(42.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 69 0 69 69 0 69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8593914,8.43097839 C29.0844224,2.67431129 20.4363344,1.50006576 13.4833866,4.87960167 L23.9128083,15.2759706 C25.0333247,16.3929359 25.0333247,18.1972644 23.9128083,19.3142296 L19.3445492,23.8680111 C18.2240329,25.0136165 16.4139679,25.0136165 15.2934516,23.8680111 L4.86402989,13.4716421 C1.50248076,20.4311949 2.68045951,28.9945952 8.45542854,34.7512623 C13.7994297,40.0783274 21.6143132,41.481694 28.2512179,38.9900023 L51.1212445,61.7875496 C54.0805569,64.7374835 58.8499343,64.7374835 61.7805156,61.7875496 C64.7398281,58.8376157 64.7398281,54.0833533 61.7805156,51.1620596 L39.0254138,28.4504326 C41.6686832,21.7486411 40.2895861,13.8439639 34.8593914,8.43097839 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiShop);
export default __webpack_public_path__ + "static/media/poi-shop.c0536d759841b47426adc783f4212ee8.svg";
export { ForwardRef as ReactComponent };